import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Tag,
    HStack
} from "@chakra-ui/react";
import moment from "moment";
import { formatNumber, getUserTimeZone } from "../../../utils/DefaultFunction";

export default function TemplatePerformanceTable({ templatePerformanceDetails }) {
    const renderColor = (name) => {
        switch (name) {
            case "Transaction":
                return "#10b981"
            case "Marketing":
                return "#8b5cf6"
            case "Informational":
                return "var(--brand-primary)"
            case "Authentication":
                return "#f97316"

            default:
                return "#8b5cf6"
        }
    }
    return (
        <TableContainer overflowX="auto" border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    overflow="hidden"> 
            <Table variant="simple" >
                <Thead >
                    <Tr>

                        <Th>Template Name</Th>
                        <Th>Type</Th>
                        <Th>Total Messages</Th>
                        <Th>Failed</Th>
                        <Th>Delivery Rate</Th>
                        <Th>Read Rate</Th>
                        <Th>Channels</Th>
                        <Th>Last Used</Th>
                    </Tr>
                </Thead>

                <Tbody>
                    {templatePerformanceDetails.map((item) => (
                        <Tr key={item.template_id}>

                            <Td>{item.template_name}</Td>
                            <Td><Tag bg={renderColor(item.type)}  color={"white"} size="sm">{item.type}</Tag></Td>
                            <Td>{formatNumber(item.total_messages)}</Td>
                            <Td color={"#fb2c36"}>{formatNumber(item.failed)}</Td>
                            <Td color={"#00a63e"}>{item.delivery_rate}%</Td>
                            <Td color={"#155dfc"}>{item.read_rate}%</Td>
                            <Td>
                                <HStack spacing={1} wrap={"wrap"}>
                                    {item.channels.map((ch) => (
                                        <Tag key={ch} bg={"#f2edee"} color={"#1e293b"} size="sm">
                                            {ch}
                                        </Tag>
                                    ))}
                                </HStack>
                            </Td>
                            <Td> {moment
                                .utc(item.last_used)
                                .tz(getUserTimeZone())
                                .format("DD MMM YY hh:mm:ss A")}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
}
